// **********************************************************************
//
// Copyright (c) 2003-2017 ZeroC, Inc. All rights reserved.
//
// This copy of Ice is licensed to you under the terms described in the
// ICE_LICENSE file included in this distribution.
//
// **********************************************************************
//
// Ice version 3.7.0
//
// <auto-generated>
//
// Generated from file `Session.ice'
//
// Warning: do not edit this file.
//
// </auto-generated>
//

/* slice2js browser-bundle-skip */
// (function(module, require, exports)
// {
/* slice2js browser-bundle-skip-end */
/* slice2js browser-bundle-skip */
    const _ModuleRegistry = require("../Ice/ModuleRegistry").Ice._ModuleRegistry;
    const Glacier2 = require("../Glacier2/SSLInfo").Glacier2;
    const Ice = 
    (
        require("../Ice/Object"),
        require("../Ice/Value"),
        require("../Ice/ObjectPrx"),
        require("../Ice/Operation"),
        require("../Ice/Exception"),
        require("../Ice/Long"),
        require("../Ice/HashMap"),
        require("../Ice/HashUtil"),
        require("../Ice/ArrayUtil"),
        require("../Ice/StreamHelpers"),
        require("../Ice/BuiltinSequences"),
        require("../Ice/Identity")
    ).Ice;

    const Slice = Ice.Slice;
/* slice2js browser-bundle-skip-end */

    /**
     * This exception is raised if an attempt to create a new session failed.
     *
     **/
    Glacier2.CannotCreateSessionException = class extends Ice.UserException
    {
        constructor(reason = "", _cause = "")
        {
            super(_cause);
            this.reason = reason;
        }

        static get _parent()
        {
            return Ice.UserException;
        }

        static get _id()
        {
            return "::Glacier2::CannotCreateSessionException";
        }

        _mostDerivedType()
        {
            return Glacier2.CannotCreateSessionException;
        }

        _writeMemberImpl(ostr)
        {
            ostr.writeString(this.reason);
        }

        _readMemberImpl(istr)
        {
            this.reason = istr.readString();
        }
    };

    Slice.PreservedUserException(Glacier2.CannotCreateSessionException);

    const iceC_Glacier2_Session_ids = [
        "::Glacier2::Session",
        "::Ice::Object"
    ];

    /**
     * A client-visible session object, which is tied to the lifecycle of a {@link Router}.
     *
     * @see Router
     * @see SessionManager
     *
     **/
    Glacier2.Session = class extends Ice.Object
    {
    };

    Glacier2.SessionPrx = class extends Ice.ObjectPrx
    {
    };

    Slice.defineOperations(Glacier2.Session, Glacier2.SessionPrx, iceC_Glacier2_Session_ids, 0,
    {
        "destroy": [, , , , , , , , , ]
    });

    const iceC_Glacier2_StringSet_ids = [
        "::Glacier2::StringSet",
        "::Ice::Object"
    ];

    /**
     * An object for managing the set of identity constraints for specific
     * parts of object identity on a
     * {@link Session}.
     *
     * @see Session
     * @see SessionControl
     *
     **/
    Glacier2.StringSet = class extends Ice.Object
    {
    };

    Glacier2.StringSetPrx = class extends Ice.ObjectPrx
    {
    };

    Slice.defineOperations(Glacier2.StringSet, Glacier2.StringSetPrx, iceC_Glacier2_StringSet_ids, 0,
    {
        "add": [, 2, 2, , , [["Ice.StringSeqHelper"]], , , , ],
        "remove": [, 2, 2, , , [["Ice.StringSeqHelper"]], , , , ],
        "get": [, 2, 2, , ["Ice.StringSeqHelper"], , , , , ]
    });

    const iceC_Glacier2_IdentitySet_ids = [
        "::Glacier2::IdentitySet",
        "::Ice::Object"
    ];

    /**
     * An object for managing the set of object identity constraints on a
     * {@link Session}.
     *
     * @see Session
     * @see SessionControl
     *
     **/
    Glacier2.IdentitySet = class extends Ice.Object
    {
    };

    Glacier2.IdentitySetPrx = class extends Ice.ObjectPrx
    {
    };

    Slice.defineOperations(Glacier2.IdentitySet, Glacier2.IdentitySetPrx, iceC_Glacier2_IdentitySet_ids, 0,
    {
        "add": [, 2, 2, , , [["Ice.IdentitySeqHelper"]], , , , ],
        "remove": [, 2, 2, , , [["Ice.IdentitySeqHelper"]], , , , ],
        "get": [, 2, 2, , ["Ice.IdentitySeqHelper"], , , , , ]
    });

    const iceC_Glacier2_SessionControl_ids = [
        "::Glacier2::SessionControl",
        "::Ice::Object"
    ];

    /**
     * An administrative session control object, which is tied to the
     * lifecycle of a {@link Session}.
     *
     * @see Session
     *
     **/
    Glacier2.SessionControl = class extends Ice.Object
    {
    };

    Glacier2.SessionControlPrx = class extends Ice.ObjectPrx
    {
    };

    Slice.defineOperations(Glacier2.SessionControl, Glacier2.SessionControlPrx, iceC_Glacier2_SessionControl_ids, 0,
    {
        "categories": [, , , , ["Glacier2.StringSetPrx"], , , , , ],
        "adapterIds": [, , , , ["Glacier2.StringSetPrx"], , , , , ],
        "identities": [, , , , ["Glacier2.IdentitySetPrx"], , , , , ],
        "getSessionTimeout": [, 2, 2, , [3], , , , , ],
        "destroy": [, , , , , , , , , ]
    });

    const iceC_Glacier2_SessionManager_ids = [
        "::Glacier2::SessionManager",
        "::Ice::Object"
    ];

    /**
     * The session manager for username/password authenticated users that
     * is responsible for managing {@link Session} objects. New session objects
     * are created by the {@link Router} object calling on an application-provided
     * session manager. If no session manager is provided by the application,
     * no client-visible sessions are passed to the client.
     *
     * @see Router
     * @see Session
     *
     **/
    Glacier2.SessionManager = class extends Ice.Object
    {
    };

    Glacier2.SessionManagerPrx = class extends Ice.ObjectPrx
    {
    };

    Slice.defineOperations(Glacier2.SessionManager, Glacier2.SessionManagerPrx, iceC_Glacier2_SessionManager_ids, 0,
    {
        "create": [, , , 2, ["Glacier2.SessionPrx"], [[7], ["Glacier2.SessionControlPrx"]], ,
        [
            Glacier2.CannotCreateSessionException
        ], , ]
    });

    const iceC_Glacier2_SSLSessionManager_ids = [
        "::Glacier2::SSLSessionManager",
        "::Ice::Object"
    ];

    /**
     * The session manager for SSL authenticated users that is
     * responsible for managing {@link Session} objects. New session objects are
     * created by the {@link Router} object calling on an application-provided
     * session manager. If no session manager is provided by the
     * application, no client-visible sessions are passed to the client.
     *
     * @see Router
     * @see Session
     *
     **/
    Glacier2.SSLSessionManager = class extends Ice.Object
    {
    };

    Glacier2.SSLSessionManagerPrx = class extends Ice.ObjectPrx
    {
    };

    Slice.defineOperations(Glacier2.SSLSessionManager, Glacier2.SSLSessionManagerPrx, iceC_Glacier2_SSLSessionManager_ids, 0,
    {
        "create": [, , , 2, ["Glacier2.SessionPrx"], [[Glacier2.SSLInfo], ["Glacier2.SessionControlPrx"]], ,
        [
            Glacier2.CannotCreateSessionException
        ], , ]
    });
/* slice2js browser-bundle-skip */
    exports.Glacier2 = Glacier2;
/* slice2js browser-bundle-skip-end */
/* slice2js browser-bundle-skip */
// }
// (typeof(global) !== "undefined" && typeof(global.process) !== "undefined" ? module : undefined,
//  typeof(global) !== "undefined" && typeof(global.process) !== "undefined" ? require : this.Ice._require,
//  typeof(global) !== "undefined" && typeof(global.process) !== "undefined" ? exports : this));
/* slice2js browser-bundle-skip-end */



//////////////////
// WEBPACK FOOTER
// ./~/ice/src/Glacier2/Session.js
// module id = 204
// module chunks = 0